<ch-loader [loading]="isInitialLoading"></ch-loader>
<div [ngStyle]="{ display: isInitialLoading ? 'none' : 'block' }">
  <ch-breadcrumb [parts]="breadcrumb" (goTo)="breadcrumbGoTo($event)"></ch-breadcrumb>
  <form (ngSubmit)="create(form)" #form="ngForm">
    <div class="container-fluid">
      <div class="row">
        <div class="col-sm-12 col-md-12">
          <div class="card mb-4">
            <div class="card-header">Form</div>
            <div class="card-body">
              <div class="form-group">
                <label for="member-edit-job-title">Add coupons mode:</label>
                <div class="form-check">
                  <input
                    id="createMode"
                    type="radio"
                    name="mode"
                    (click)="importMode(true)"
                    checked
                  />
                  <label class="form-check-label" for="createMode">Create</label>
                </div>
                <div class="form-check">
                  <input
                    id="importMode"
                    type="radio"
                    name="mode"
                    (click)="importMode(false)"
                  />
                  <label class="form-check-label" for="importMode">Import</label>
                </div>
              </div>
              <div class="form-group">
                <label for="coupons-edit-name">Name</label>
                <input
                  type="text"
                  [(ngModel)]="CouponsData.name"
                  name="name"
                  #name="ngModel"
                  class="form-control"
                  id="coupons-edit-name"
                  required
                  [readonly]="loading"
                />
                <small class="text-danger" *ngIf="(name.touched || name.dirty) && !name.valid"> Name is invalid. </small>
              </div>
              <ng-container *ngIf="isCreateMode; else import">
                <div class="form-group">
                  <label for="coupons-edit-durationInMonths">Duration (months)</label>
                  <input
                    type="number"
                    [(ngModel)]="CouponsData.durationInMonths"
                    name="durationInMonths"
                    #durationInMonths="ngModel"
                    class="form-control"
                    id="coupons-edit-durationInMonths"
                    required
                    [readonly]="loading"
                  />
                  <small class="text-danger" *ngIf="(durationInMonths.touched || durationInMonths.dirty) && !durationInMonths.valid"> Duration is invalid. </small>
                </div>
                <div class="form-group">
                  <label for="discount-input">Percent discount</label>
                  <input
                    type="number"
                    id="discount-input"
                    [(ngModel)]="CouponsData.percentOff"
                    name="percentOff"
                    class="form-control"
                    #percentOff="ngModel"
                    required
                    [readonly]="loading"
                  />
                  <small class="text-danger" *ngIf="errors.percentOff || ((percentOff.touched || percentOff.dirty) && !percentOff.valid)">
                    Percent discount is required.
                  </small>
                </div>
              </ng-container>
              <ng-template #import>
                <div class="form-group">
                  <label for="coupons-edit-stripeId">Stripe ID</label>
                  <input
                    type="text"
                    [(ngModel)]="CouponsData.stripeId"
                    name="stripeId"
                    #stripeId="ngModel"
                    class="form-control"
                    id="coupons-edit-stripeId"
                    required
                    [readonly]="loading"
                  />
                  <small class="text-danger" *ngIf="(stripeId.touched || stripeId.dirty) && !stripeId.valid"> Stripe ID is invalid. </small>
                </div>
              </ng-template>




              <div style="margin-top: 40px;">
                <span class="btn-right">
                  <button id='couponsEditCancel' type="button" class="btn btn-secondary" (click)="cancel()" [disabled]="loading">Cancel</button>
                  <button id='couponsEditSave' type="submit" class="btn btn-primary" [disabled]="loading">Save</button>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>
</div>



// WEBPACK FOOTER //
// /Users/thxgg/Projects/Work/code-hospitality-cms/src/app/coupons/coupons-edit/coupons-edit.component.html